<div class="color-yield-wrapper" [ngClass]="{ 'has-text': text }">
  <div class="small-circle m-a-0" [ngStyle]="{ background: color }"></div>
  <span *ngIf="text" class="m-l-sm">{{ text }}</span>
</div>
